import { render, staticRenderFns } from "./CtrlEquipesPage.vue?vue&type=template&id=2cd399a4"
import script from "./CtrlEquipesPage.vue?vue&type=script&lang=js"
export * from "./CtrlEquipesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports